import dayjs from "dayjs"
import { set } from "lodash-es"
import { action, makeAutoObservable, observable } from "mobx"

export type PageSetting = {
  path: string
  prefix_path: string
  language: string
  title: string
  description: string
  button: string
  add_widget_url: string
}
export default class ReturnPageSettingStore {
  @observable dataLoadedTime: number = 0
  // 保存按钮活跃状态
  @observable public saveLoading = false
  // 小部件数据加载
  @observable public widgetFormLoading = false
  // 保存按钮活跃状态
  @observable public saveBtnActive = false
  @observable public targetLink = ""
  // 配置数据
  @observable config: PageSetting = {
    path: "",
    prefix_path: "apps",
    language: "",
    title: "",
    description: "",
    button: "",
    add_widget_url: "",
  }
  @observable transList: any = {}
  @observable isShowOrderReturn: number = 2

  constructor() {
    // 使用这个才会在 MobX 6 上才会更新视图
    makeAutoObservable(this)
  }

  @action.bound
  public setConfig(config: PageSetting) {
    this.dataLoadedTime = dayjs().unix()
    this.config = config
  }
  @action.bound
  public setTransList(info) {
    this.transList = info
  }
  @action.bound
  public setTargetLink(link: string) {
    this.targetLink = link
  }

  @action.bound
  public setTargetConfig(path: string, value: string) {
    set(this.config, path, value)
  }
  /**
   * 切换当前保存激活状态
   */
  @action.bound
  public setSaveBtnActive(type: boolean): void {
    this.saveBtnActive = type
  }

  @action.bound
  setDataLoadedTime(time: number) {
    this.dataLoadedTime = time
  }

  /**
   * 切换保存Loading状态
   */
  @action.bound
  public setSaveLoading(type: boolean): void {
    this.saveLoading = type
  }

  /**
   * 切换保存Loading状态
   */
  @action.bound
  public setWidgetFormLoading(type: boolean): void {
    this.widgetFormLoading = type
  }

  /**
   * 切换保存Loading状态
   */
  @action.bound
  public setIsShowOrderReturn(val: number): void {
    this.isShowOrderReturn = val
  }
}
